// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/outview3.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* div {
  border: 1px solid black;
} */

.section8_container__zJUKI {
  /*background-image: url(/public/images/outview3.png); */
  background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  backdrop-filter: grayscale(100%);
  display: flex;
  flex-direction: column;
  align-items: center; /* 세로 중앙 정렬 */
  padding: 5%;
}

.section8_text-small__ReRT4 {
  text-align: center;
  letter-spacing: 5px;
  font-size: 16px;
  color: white;
}

.section8_text-mid__WTA25 {
  text-align: center;
  font-size: 21px;
  color: white;
  padding-left: 10%;
  padding-right: 10%;
}

.section8_text-item-1__mZjSB {
  text-align: left;
  font-size: 21px;
  color: #0c78b7;
  font-weight: 800;
}

.section8_text-item-2__kVRRL {
  text-align: left;
  font-size: 18px;
  color: black;
}

.section8_text-large__MLMvK {
  text-align: center;
  margin: 0;
  font-size: 45px;
  color: white;
  font-weight: 500;
}

.section8_grid-container__u3dHY {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 70%;
  background-color: rgba(255, 255, 255, 0.9);
  padding-left: 4%;
  padding-right: 4%;
  padding-top: 2%;
  padding-bottom: 2%;
}

.section8_item__CsWdG {
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid rgb(182, 182, 182);
  border-right: 1px solid rgb(182, 182, 182);
  background-color: transparent;
  padding-left: 5%;
}

@media (max-width: 767px) {
  .section8_grid-container__u3dHY {
    grid-template-columns: 1fr;
  }

  .section8_container__zJUKI br {
    display: none;
  }

  .section8_text-small__ReRT4 {
    font-size: 10px;
  }

  .section8_text-mid__WTA25 {
    font-size: 14px;
  }

  .section8_text-large__MLMvK {
    font-size: 36px;
  }

  .section8_text-item-1__mZjSB {
    font-size: 20px;
  }

  .section8_grid-container__u3dHY {
    padding-left: 3%;
    padding-right: 3%;
    width: 90%;
  }

  .section8_item__CsWdG {
    padding: 5px;
    text-align: center;
    border-bottom: 1px solid rgb(182, 182, 182);
    border-right: 1px solid rgb(182, 182, 182);
    background-color: transparent;
  }

  .section8_text-item-2__kVRRL {
    text-align: left;
    font-size: 15px;
    color: black;
  }

  /* 오른쪽 끝 요소는 border-right 제거 */
  .section8_item__CsWdG:nth-child(1n) {
    border-right: none;
  }

  /* 마지막 두 개의 요소는 border-bottom 제거 */
  .section8_item__CsWdG:nth-last-child(-n + 1) {
    border-bottom: none;
  }
}

@media (min-width: 768px) {
  .section8_text-large__MLMvK {
    font-size: 80px;
  }

  .section8_text-mid__WTA25 {
    margin-bottom: 80px;
  }

  /* 오른쪽 끝 요소는 border-right 제거 */
  .section8_item__CsWdG:nth-child(2n) {
    border-right: none;
  }

  /* 마지막 두 개의 요소는 border-bottom 제거 */
  .section8_item__CsWdG:nth-last-child(-n + 2) {
    border-bottom: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Sections/section8.module.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,uDAAuD;EACvD;2CACoC;EACpC,sBAAsB;EACtB,2BAA2B;EAC3B,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,aAAa;EAClC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,UAAU;EACV,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,0CAA0C;IAC1C,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;;EAEA,8BAA8B;EAC9B;IACE,kBAAkB;EACpB;;EAEA,kCAAkC;EAClC;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,8BAA8B;EAC9B;IACE,kBAAkB;EACpB;;EAEA,kCAAkC;EAClC;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* div {\n  border: 1px solid black;\n} */\n\n.container {\n  /*background-image: url(/public/images/outview3.png); */\n  background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),\n    url(\"/public/images/outview3.png\");\n  background-size: cover;\n  background-position: center;\n  backdrop-filter: grayscale(100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* 세로 중앙 정렬 */\n  padding: 5%;\n}\n\n.text-small {\n  text-align: center;\n  letter-spacing: 5px;\n  font-size: 16px;\n  color: white;\n}\n\n.text-mid {\n  text-align: center;\n  font-size: 21px;\n  color: white;\n  padding-left: 10%;\n  padding-right: 10%;\n}\n\n.text-item-1 {\n  text-align: left;\n  font-size: 21px;\n  color: #0c78b7;\n  font-weight: 800;\n}\n\n.text-item-2 {\n  text-align: left;\n  font-size: 18px;\n  color: black;\n}\n\n.text-large {\n  text-align: center;\n  margin: 0;\n  font-size: 45px;\n  color: white;\n  font-weight: 500;\n}\n\n.grid-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  width: 70%;\n  background-color: rgba(255, 255, 255, 0.9);\n  padding-left: 4%;\n  padding-right: 4%;\n  padding-top: 2%;\n  padding-bottom: 2%;\n}\n\n.item {\n  padding: 20px;\n  text-align: center;\n  border-bottom: 1px solid rgb(182, 182, 182);\n  border-right: 1px solid rgb(182, 182, 182);\n  background-color: transparent;\n  padding-left: 5%;\n}\n\n@media (max-width: 767px) {\n  .grid-container {\n    grid-template-columns: 1fr;\n  }\n\n  .container br {\n    display: none;\n  }\n\n  .text-small {\n    font-size: 10px;\n  }\n\n  .text-mid {\n    font-size: 14px;\n  }\n\n  .text-large {\n    font-size: 36px;\n  }\n\n  .text-item-1 {\n    font-size: 20px;\n  }\n\n  .grid-container {\n    padding-left: 3%;\n    padding-right: 3%;\n    width: 90%;\n  }\n\n  .item {\n    padding: 5px;\n    text-align: center;\n    border-bottom: 1px solid rgb(182, 182, 182);\n    border-right: 1px solid rgb(182, 182, 182);\n    background-color: transparent;\n  }\n\n  .text-item-2 {\n    text-align: left;\n    font-size: 15px;\n    color: black;\n  }\n\n  /* 오른쪽 끝 요소는 border-right 제거 */\n  .item:nth-child(1n) {\n    border-right: none;\n  }\n\n  /* 마지막 두 개의 요소는 border-bottom 제거 */\n  .item:nth-last-child(-n + 1) {\n    border-bottom: none;\n  }\n}\n\n@media (min-width: 768px) {\n  .text-large {\n    font-size: 80px;\n  }\n\n  .text-mid {\n    margin-bottom: 80px;\n  }\n\n  /* 오른쪽 끝 요소는 border-right 제거 */\n  .item:nth-child(2n) {\n    border-right: none;\n  }\n\n  /* 마지막 두 개의 요소는 border-bottom 제거 */\n  .item:nth-last-child(-n + 2) {\n    border-bottom: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `section8_container__zJUKI`,
	"text-small": `section8_text-small__ReRT4`,
	"text-mid": `section8_text-mid__WTA25`,
	"text-item-1": `section8_text-item-1__mZjSB`,
	"text-item-2": `section8_text-item-2__kVRRL`,
	"text-large": `section8_text-large__MLMvK`,
	"grid-container": `section8_grid-container__u3dHY`,
	"item": `section8_item__CsWdG`
};
export default ___CSS_LOADER_EXPORT___;
